import cls from 'classnames';

import RenderLabel from '@/media/components/RenderLabel/RenderLabel';

import styles from './PreviewImage.module.css';

export interface PreviewImageProps {
  url: string;
  size: number;
  bg?: Nullable<string>;
  isRender?: boolean;
  isRenderLabelExpandable?: boolean;
  className?: string;
  renderLabelClassName?: string;
}

function PreviewImage(props: PreviewImageProps) {
  const { url, size, bg, isRender = false, isRenderLabelExpandable = true, className, renderLabelClassName } = props;

  return (
    <div className={styles.previewImage}>
      <img
        className={cls(styles.image, className)}
        src={url}
        width={size}
        height={size}
        alt=""
        loading="lazy"
        decoding="async"
        style={{ backgroundColor: bg ?? undefined }}
      />

      {isRender && (
        <RenderLabel
          bgColor={bg}
          className={renderLabelClassName}
          mediaSize={size}
          isExpandable={isRenderLabelExpandable}
        />
      )}
    </div>
  );
}

export default PreviewImage;
